const elements = document.querySelectorAll('[data-animate]');

// Objeto para almacenar las animaciones activas
const activeAnimations = new Map();

const observer = new IntersectionObserver(
    (entries) => {
        entries.forEach((entry) => {
            const el = entry.target;
            const animation = el.dataset.animate;
            const delay = parseFloat(el.dataset.delay || 0);
            const duration = parseFloat(el.dataset.duration || 1);

            if (entry.isIntersecting) {
                // Elemento entra al viewport - ejecutar animación
                executeAnimation(el, animation, delay, duration);
            } else {
                // Elemento sale del viewport - resetear a estado inicial
                resetElement(el, animation);
            }
        });
    },
    {
        threshold: 0.1,
        rootMargin: '-10px', // Pequeño margen para evitar parpadeos
    }
);

function executeAnimation(el, animation, delay, duration) {
    // Limpiar animaciones previas si existen
    if (activeAnimations.has(el)) {
        activeAnimations.get(el).kill();
    }

    const animateOptions = { delay, duration, ease: 'power2.out' };
    let tween;

    switch (animation) {
        case 'fade-in':
            tween = gsap.fromTo(el, { opacity: 0, y: 20 }, { opacity: 1, y: 0, ...animateOptions });
            break;
        case 'fade-out':
            tween = gsap.fromTo(el, { opacity: 1 }, { opacity: 0, ...animateOptions });
            break;

        case 'fade-up':
            tween = gsap.fromTo(el, { opacity: 0, y: 50 }, { opacity: 1, y: 0, ...animateOptions });
            break;
        case 'fade-down':
            tween = gsap.fromTo(el, { opacity: 0, y: -50 }, { opacity: 1, y: 0, ...animateOptions });
            break;
        case 'fade-left':
            tween = gsap.fromTo(el, { opacity: 0, x: 50 }, { opacity: 1, x: 0, ...animateOptions });
            break;
        case 'fade-right':
            tween = gsap.fromTo(el, { opacity: 0, x: -50 }, { opacity: 1, x: 0, ...animateOptions });
            break;

        case 'slide-up':
            tween = gsap.fromTo(
                el,
                { y: 100, opacity: 0 },
                { y: 0, opacity: 1, ease: 'power3.out', ...animateOptions }
            );
            break;
        case 'slide-down':
            tween = gsap.fromTo(
                el,
                { y: -100, opacity: 0 },
                { y: 0, opacity: 1, ease: 'power3.out', ...animateOptions }
            );
            break;
        case 'slide-left':
            tween = gsap.fromTo(
                el,
                { x: 100, opacity: 0 },
                { x: 0, opacity: 1, ease: 'power3.out', ...animateOptions }
            );
            break;
        case 'slide-right':
            tween = gsap.fromTo(
                el,
                { x: -100, opacity: 0 },
                { x: 0, opacity: 1, ease: 'power3.out', ...animateOptions }
            );
            break;

        case 'slide-up-left':
            tween = gsap.fromTo(
                el,
                { x: 80, y: 80, opacity: 0 },
                {
                    x: 0,
                    y: 0,
                    opacity: 1,
                    ease: 'power3.out',
                    ...animateOptions,
                }
            );
            break;
        case 'slide-up-right':
            tween = gsap.fromTo(
                el,
                { x: -80, y: 80, opacity: 0 },
                {
                    x: 0,
                    y: 0,
                    opacity: 1,
                    ease: 'power3.out',
                    ...animateOptions,
                }
            );
            break;
        case 'slide-down-left':
            tween = gsap.fromTo(
                el,
                { x: 80, y: -80, opacity: 0 },
                {
                    x: 0,
                    y: 0,
                    opacity: 1,
                    ease: 'power3.out',
                    ...animateOptions,
                }
            );
            break;
        case 'slide-down-right':
            tween = gsap.fromTo(
                el,
                { x: -80, y: -80, opacity: 0 },
                {
                    x: 0,
                    y: 0,
                    opacity: 1,
                    ease: 'power3.out',
                    ...animateOptions,
                }
            );
            break;

        case 'zoom-in':
            tween = gsap.fromTo(el, { scale: 0.5, opacity: 0 }, { scale: 1, opacity: 1, ...animateOptions });
            break;
        case 'zoom-out':
            tween = gsap.fromTo(el, { scale: 1.5, opacity: 0 }, { scale: 1, opacity: 1, ...animateOptions });
            break;
        case 'scale-up':
            tween = gsap.fromTo(
                el,
                { scaleY: 0, opacity: 0 },
                {
                    scaleY: 1,
                    opacity: 1,
                    transformOrigin: 'bottom',
                    ...animateOptions,
                }
            );
            break;
        case 'scale-down':
            tween = gsap.fromTo(
                el,
                { scaleY: 0, opacity: 0 },
                {
                    scaleY: 1,
                    opacity: 1,
                    transformOrigin: 'top',
                    ...animateOptions,
                }
            );
            break;

        case 'bounce':
            tween = gsap.fromTo(
                el,
                { y: -80, opacity: 0 },
                { y: 0, opacity: 1, ease: 'bounce.out', ...animateOptions }
            );
            break;

        case 'shake':
            gsap.set(el, { opacity: 1 });

            tween = gsap.timeline({
                delay,
                repeat: -1,
                repeatDelay: 3.0,
            });

            tween
                .to(el, { x: -10, duration: 0.1, ease: 'power2.inOut' })
                .to(el, { x: 10, duration: 0.1, ease: 'power2.inOut' })
                .to(el, { x: -8, duration: 0.08, ease: 'power2.inOut' })
                .to(el, { x: 8, duration: 0.08, ease: 'power2.inOut' })
                .to(el, { x: -6, duration: 0.06, ease: 'power2.inOut' })
                .to(el, { x: 6, duration: 0.06, ease: 'power2.inOut' })
                .to(el, { x: -4, duration: 0.04, ease: 'power2.inOut' })
                .to(el, { x: 4, duration: 0.04, ease: 'power2.inOut' })
                .to(el, { x: 0, duration: 0.1, ease: 'power2.out' });
            break;

        case 'rotate-in':
            tween = gsap.fromTo(
                el,
                { rotation: -180, opacity: 0, scale: 0.5 },
                { rotation: 0, opacity: 1, scale: 1, ...animateOptions }
            );
            break;
        case 'rotate-out':
            tween = gsap.fromTo(
                el,
                { rotation: 180, opacity: 0, scale: 0.5 },
                { rotation: 0, opacity: 1, scale: 1, ...animateOptions }
            );
            break;

        case 'flip-x':
            tween = gsap.fromTo(
                el,
                { rotationX: -90, opacity: 0 },
                {
                    rotationX: 0,
                    opacity: 1,
                    transformOrigin: 'center',
                    ...animateOptions,
                }
            );
            break;
        case 'flip-y':
            tween = gsap.fromTo(
                el,
                { rotationY: -90, opacity: 0 },
                {
                    rotationY: 0,
                    opacity: 1,
                    transformOrigin: 'center',
                    ...animateOptions,
                }
            );
            break;

        case 'draw-svg':
            const svgElements = el.querySelectorAll('path, line, circle, rect, ellipse, polygon, polyline');

            if (svgElements.length > 0) {
                tween = gsap.timeline({ delay });

                svgElements.forEach((svgEl, index) => {
                    const originalFill = svgEl.getAttribute('fill') || '#000';
                    const originalStroke = svgEl.getAttribute('stroke');

                    const length = svgEl.getTotalLength
                        ? svgEl.getTotalLength()
                        : svgEl.getBoundingClientRect().width + svgEl.getBoundingClientRect().height;

                    gsap.set(svgEl, {
                        fill: 'none',
                        stroke: originalFill,
                        strokeWidth: originalStroke ? svgEl.getAttribute('stroke-width') || 1 : 0.8,
                        strokeDasharray: length,
                        strokeDashoffset: length,
                        opacity: 1,
                    });

                    tween.to(
                        svgEl,
                        {
                            strokeDashoffset: 0,
                            duration: duration * 0.6,
                            ease: 'power2.inOut',
                        },
                        index * 0.1
                    );

                    tween.to(
                        svgEl,
                        {
                            fill: originalFill,
                            stroke: 'none',
                            strokeWidth: 0,
                            duration: duration * 0.4,
                            ease: 'power2.out',
                        },
                        '-=0.1'
                    );
                });
            } else {
                tween = gsap.fromTo(el, { opacity: 0 }, { opacity: 1, ...animateOptions });
            }
            break;

        case 'count-up':
            const targetNumber = parseInt(el.textContent.replace(/[^\d]/g, '')) || 0;
            const prefix = el.textContent.replace(/[\d,]/g, '');

            gsap.set(el, { opacity: 1 });

            // Crear un objeto para animar
            const counter = { value: 0 };

            tween = gsap.to(counter, {
                value: targetNumber,
                duration,
                delay,
                ease: 'power2.out',
                onUpdate: function () {
                    // Incrementar de forma secuencial desde 0 hasta el número objetivo
                    const currentValue = Math.floor(counter.value);
                    el.textContent = prefix + currentValue.toLocaleString();
                },
                onComplete: function () {
                    el.textContent = prefix + targetNumber.toLocaleString();
                },
            });
            break;
        default:
            tween = gsap.fromTo(el, { opacity: 0 }, { opacity: 1, ...animateOptions });
    }

    // Guardar la animación activa
    if (tween) {
        activeAnimations.set(el, tween);
    }
}

function resetElement(el, animation) {
    // Limpiar animaciones activas
    if (activeAnimations.has(el)) {
        activeAnimations.get(el).kill();
        activeAnimations.delete(el);
    }

    // Resetear el elemento a su estado inicial según el tipo de animación
    switch (animation) {
        case 'fade-in':
            gsap.set(el, { opacity: 0, y: 20 });
            break;
        case 'fade-out':
            gsap.set(el, { opacity: 1 });
            break;
        case 'fade-up':
            gsap.set(el, { opacity: 0, y: 50 });
            break;
        case 'fade-down':
            gsap.set(el, { opacity: 0, y: -50 });
            break;
        case 'fade-left':
            gsap.set(el, { opacity: 0, x: 50 });
            break;
        case 'fade-right':
            gsap.set(el, { opacity: 0, x: -50 });
            break;
        case 'slide-up':
            gsap.set(el, { y: 100, opacity: 0 });
            break;
        case 'slide-down':
            gsap.set(el, { y: -100, opacity: 0 });
            break;
        case 'slide-left':
            gsap.set(el, { x: 100, opacity: 0 });
            break;
        case 'slide-right':
            gsap.set(el, { x: -100, opacity: 0 });
            break;
        case 'slide-up-left':
            gsap.set(el, { x: 80, y: 80, opacity: 0 });
            break;
        case 'slide-up-right':
            gsap.set(el, { x: -80, y: 80, opacity: 0 });
            break;
        case 'slide-down-left':
            gsap.set(el, { x: 80, y: -80, opacity: 0 });
            break;
        case 'slide-down-right':
            gsap.set(el, { x: -80, y: -80, opacity: 0 });
            break;
        case 'zoom-in':
            gsap.set(el, { scale: 0.5, opacity: 0 });
            break;
        case 'zoom-out':
            gsap.set(el, { scale: 1.5, opacity: 0 });
            break;
        case 'scale-up':
            gsap.set(el, { scaleY: 0, opacity: 0 });
            break;
        case 'scale-down':
            gsap.set(el, { scaleY: 0, opacity: 0 });
            break;
        case 'bounce':
            gsap.set(el, { y: -80, opacity: 0 });
            break;
        case 'shake':
            gsap.set(el, { x: 0, opacity: 1 });
            break;
        case 'rotate-in':
            gsap.set(el, { rotation: -180, opacity: 0, scale: 0.5 });
            break;
        case 'rotate-out':
            gsap.set(el, { rotation: 180, opacity: 0, scale: 0.5 });
            break;
        case 'flip-x':
            gsap.set(el, { rotationX: -90, opacity: 0 });
            break;
        case 'flip-y':
            gsap.set(el, { rotationY: -90, opacity: 0 });
            break;
        case 'draw-svg':
            const svgElements = el.querySelectorAll('path, line, circle, rect, ellipse, polygon, polyline');

            if (svgElements.length > 0) {
                svgElements.forEach((svgEl) => {
                    const originalFill = svgEl.getAttribute('fill') || '#000';
                    const length = svgEl.getTotalLength
                        ? svgEl.getTotalLength()
                        : svgEl.getBoundingClientRect().width + svgEl.getBoundingClientRect().height;

                    gsap.set(svgEl, {
                        fill: 'none',
                        stroke: originalFill,
                        strokeWidth: 0.8,
                        strokeDasharray: length,
                        strokeDashoffset: length,
                        opacity: 1,
                    });
                });
            } else {
                gsap.set(el, { opacity: 0 });
            }
            break;
        default:
            gsap.set(el, { opacity: 0 });
    }
}

// Inicializar todos los elementos en su estado inicial
elements.forEach((el) => {
    const animation = el.dataset.animate;
    resetElement(el, animation);
    observer.observe(el);
});
